import { STEP } from '~/lib/fileFormat'

import stepLogo from './icon_step.svg'
import stlLogo from './icon_stl.svg'
import icon from './icon.svg'

export default function getPlaceholderImage(fileFormat, iconOnly = false) {
    if (iconOnly) {
        return icon
    }
    if (fileFormat === STEP) {
        return stepLogo
    }
    return stlLogo
}
